import { bizViewSchema, profileSchema, projectSchema, webAppSchema } from '../model'

const actionRef = {
  bizview: {
    color: 'yellow',
    icon: 'fas fa-eye',
    label: 'BizView',
    schema: bizViewSchema
  },
  project: {
    color: 'green',
    icon: 'fas fa-project-diagram',
    label: 'Project',
    schema: projectSchema
  },
  workspace: {
    color: 'red',
    icon: 'fas fa-building',
    label: 'Workspace',
    schema: null
  },
  webapp: {
    color: 'pink',
    icon: 'fab fa-weebly',
    label: 'WebApp',
    schema: webAppSchema,
    goToDefaultView: function (vueThis, item) {
      vueThis.$router.push({
        path: `${vueThis.appRoute.path}/174/panel`,
        query: {
          webAppPreviewId: item.id
        }
      })
    }
  },
  profile: {
    color: 'cyan',
    icon: 'fas fa-id-badge',
    label: 'Profile',
    schema: profileSchema
  }
}

export const entityTypeIconMixin = {
  methods: {
    entityTypeReference (entityTypeName) {
      return actionRef[entityTypeName] || { color: 'grey', icon: '', label: 'Unknown action' }
    },
    entityTypeColor (entityTypeName) {
      return this.entityTypeReference(entityTypeName).color || ''
    },
    entityTypeIcon (entityTypeName) {
      return this.entityTypeReference(entityTypeName).icon || ''
    },
    entityTypeName (entityTypeName) {
      return this.entityTypeReference(entityTypeName).label || ''
    }
  }
}
